export default "__VITE_ASSET__BBqyz2Cd__"